module.exports = "md-input-container,\n.input-container md-select\n{\n    width: 95%;\n    padding-top:10px;\n}\n.input-container{\n    padding: 20px 0px !important;\n}\nmd-card {\n    padding: 12px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/cart/checkout/checkout.component.css
// module id = ./src/app/cart/checkout/checkout.component.css
// module chunks = main